import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} CarrierIntegration
 * @property {string} nickName
 * @property {string} carrierName
 * @property {string} carrierId
 */

/**
 * @typedef {Object} CarrierIntegrationsSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {CarrierIntegration[]} data
 */

export const CARRIER_INTEGRATIONS_ACTIONS = {
  SET_CARRIER_INTEGRATIONS: 'SET_CARRIER_INTEGRATIONS',
  SET_STATUS: 'SET_CARRIER_INTEGRATIONS_STATUS',
  SET_ERRORS: 'SET_CARRIER_INTEGRATIONS_ERRORS',
  CLEAR_ERRORS: 'CLEAR_CARRIER_INTEGRATIONS_ERRORS'
}

export const initialCarrierIntegrationsState = {
  status: 'idle',
  errors: [],
  data: []
}

export const carrierIntegrationsPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      nickName: PropTypes.string,
      carrierName: PropTypes.string,
      carrierId: PropTypes.string
    })
  )
}
